import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, InlineNotification} from '@veneer/core';

const LicenseValidateError = ({csvFileContent}: {csvFileContent: string}): JSX.Element => {
    const {t} = useTranslation(['licenses']);

    const downloadCSV = useCallback(() => {
        const blob = new Blob([csvFileContent], {type: 'text/csv'});
        const url = URL.createObjectURL(blob);
        // eslint-disable-next-line i18next/no-literal-string
        const a = document.createElement('a');
        a.href = url;
        a.download = 'error.csv';
        a.click();
        URL.revokeObjectURL(url);
    }, [csvFileContent]);

    return (
        <>
            <InlineNotification
                closeButton={false}
                type="negative"
                title={t('licenses:csvImportValidateError', 'CSV content is invalid')}
                i18n={{close: t('licenses:close', 'Close')}}
            />
            <Button onClick={downloadCSV}>{t('licenses:csvDownload', 'Download CSV')}</Button>
        </>
    );
};

export default LicenseValidateError;
